import { FileSearchOutlined } from "@ant-design/icons";
import { Modal, Typography } from "antd";

export const AgentDetailModal = ({ visible, onCancel, selectedRow }) => (
    <Modal
        visible={visible}
        footer={null}
        onCancel={onCancel}
        title={
            <Typography.Title style={{ textAlign: "left", marginLeft: 12 }} level={4}>
                <FileSearchOutlined style={{ marginRight: 4 }} />
                Detalle de los Agentes
            </Typography.Title>
        }
        centered
        width="70%"
        styles={{
            header: { background: "#fff" },
        }}
    >
        {selectedRow && (
            <div style={{ padding: 10 }}>
                <p><b>Agente:</b> {selectedRow.agentName}</p>
                <p><b>Objetivo:</b> {selectedRow.objective}</p>
                <p><b>Actividades:</b> {selectedRow.activity}</p>
                <p><b>Input:</b> {selectedRow.inputs}</p>
                <p><b>Output:</b> {selectedRow.outputs}</p>
            </div>
        )}
    </Modal>
);